import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-users fa-4x" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-white text-hover-white" }, "Invite People", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column flex-md-row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "btn btn-primary d-block d-md-none" }, "invite more people", -1)
const _hoisted_8 = { class: "d-flex align-items-center border border-dotted mb-8 p-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px me-4 bg-primary" }, null, -1)
const _hoisted_10 = { class: "symbol symbol-35px symbol-circle" }
const _hoisted_11 = {
  key: 0,
  class: "symbol-label bg-light-primary text-white fw-bold"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "flex-grow-1 ms-2" }
const _hoisted_14 = { class: "text-white fw-bolder fs-6" }
const _hoisted_15 = { class: "text-muted fw-bold d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_AddPeopleModal = _resolveComponent("AddPeopleModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.pendingInvitations.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: _ctx.emptyBlurb
          }, {
            image: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "btn btn-sm btn-primary d-flex flex-column flex-center",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.invokeAddPeople && _ctx.invokeAddPeople(...args)))
              }, _hoisted_5)
            ]),
            _: 1
          }, 8, ["description"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingInvitations, (person) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "",
                key: person.accountId
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    (!person.avatar)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(person.fullName[0]), 1))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          alt: "Pic",
                          src: person.avatar
                        }, null, 8, _hoisted_12))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(person.fullName), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(person.title) + " - " + _toDisplayString(_ctx.getRole(person.role).name), 1)
                  ])
                ])
              ]))
            }), 128))
          ]))
    ]),
    _createVNode(_component_AddPeopleModal, {
      onAdded: _ctx.fetch,
      ref: "addPeopleModal"
    }, null, 8, ["onAdded"])
  ]))
}